<template>
  <b-card class="uk-text-center uk-margin-remove">
    <slot></slot>
  </b-card>
</template>

<script>
export default {
  name: 'CommonPagesFormCard'
}
</script>

<style scoped></style>
